import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-lesson-detail-box',
  styleUrls: ['./private-class-lesson-detail-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <main class="d-flex flex-1 align-items-center flex-column">
      <div class="d-flex align-items-center flex-column w-100">
        <div [ngClass]="'confirmation-message w-100 pt-3 pb-1 text-center ' + (showBorderBottom ? ' blue-border' : '')">
          <h5 *ngIf="selectedLesson" class="fw-bold px-5  py-4 lh-4 m-0">{{ selectedLesson.displayName }}</h5>
          <div *ngIf="selectedLesson" class="slides-section d-flex justify-content-center w-100 px-3">
            <lp2-private-class-download-slides-link
              [lesson]="selectedLesson"
              class="download-button p-3"
            ></lp2-private-class-download-slides-link>
          </div>
        </div>
      </div>
      <ng-container *ngIf="showTileEffect">
        <div class="tile-effect-1"></div>
        <div class="tile-effect-2"></div>
      </ng-container>
    </main>
  `,
})
export class PrivateClassLessonDetailBoxComponent {
  @Input() selectedLesson: PrivateClassLesson;
  @Input() showTileEffect = false;
  @Input() showBorderBottom = false;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-lesson-detail-box/private-class-lesson-detail-box.component.ts